import { createContext } from 'react';

export const loggedInUser = createContext("");